export default "/images/677bf7ea5620535c01c284cfa120890f.avif";